import { defaultTo } from 'ramda';
import { IAgentSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

export function getMasterAgent({ masterAgent }: IAgentSchema) {
  return defaultTo(undefined, masterAgent);
}
